import {Component, ElementRef, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import {CuentasJardinModel, CuentasModel, EncargadoRegionalModel, Region, ResponseCuentasModel} from 'src/app/model/Cuentas.model';
import { apiService } from 'src/app/service/api.service';
import { environment } from 'src/environments/environment';
import {JardinModel} from '../../../../model/Jardin.model';
import {BibliotecaModel, ResponseBiblioteca} from '../../../../model/Biblioteca.model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BibliotecaService} from '../../../../service/biblioteca.service';
import {StorageService} from '../../../../service/storage.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bibioteca-admin',
  templateUrl: './bibioteca-admin.component.html',
  styleUrls: ['./bibioteca-admin.component.css']
})
export class BibiotecaAdminComponent implements OnInit {

  cargando = false;
  @Input() region : Region;
  displayedColumns=[];
  displayedColumnsArchivos=[];
  filterValues = {};
  filterSelectObj = [];
  tipoCampos = [];
  arrayComunas = [];
  regiones = [];
  programas = [];
  dataSource: MatTableDataSource<CuentasJardinModel>;
  dataSourceArchivos: MatTableDataSource<BibliotecaModel>;
  palabraClave: string;
  idRegion:number;
  idComuna:number;
  idPrograma:number;
  pageEvent: PageEvent;
  pageIndex:number;
  length:number;
  pageIndexArchivos:number;
  lengthArchivos:number;
  getSelect = false;
  apiEndpoint = environment.apiEndpoint;
  columnNames = [
    { id: 'region', value: 'region' },
    { id: 'comuna', value: 'comuna' },
    { id: 'modalidad', value: 'modalidad' },
    { id: 'programa', value: 'programa' },
    { id: 'codigo', value: 'codigo' },
    { id: 'jardin', value: 'jardin' },
    { id: 'estado', value: 'estado' },
  ];

  columnArchivosNames = [
    { id: 'filename', value: 'filename' },
    { id: 'fecha_creacion', value: 'fecha_creacion' }
  ];

  archivoCargado = false;

  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;
  @ViewChild('modalCargarArchivo', { static: true }) modalCargarArchivo: TemplateRef<any>;

  @ViewChild('inputFile') inputArchivo: ElementRef;
  @ViewChild('divSpinnerModal') divSpinnerModal:ElementRef;

  @Input() infoSelectJardin: CuentasModel;
  public isCollapsed1 = false;
  public isCollapsed2 = true;
  public isCollapsed3 = true;
  public isCollapsed4 = false;
  public isCollapsed5 = true;
  public isCollapsed6 = true;
  dataJardin = new JardinModel();

  archivosGenerales:BibliotecaModel[];
  dataArchivo = new FormData();
  nombreArchivo:string;

  url:string ;
  urlSafe: SafeResourceUrl;

  constructor(
      public dialog: MatDialog,
      private api: apiService,
      private modal: NgbModal,
      private spinner: NgxSpinnerService,
      private bibliotecaService:BibliotecaService,
      private storageService: StorageService,
      public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.palabraClave = "";
    this.idComuna = 0;
    this.idPrograma = 0;
    this.idRegion = 0;
    this.getSelectCuentas();

    this.dataJardin = this.api.dataJardin;
    this.getDocuments();
  }

  getDocuments(){
    this.spinner.show();
    this.bibliotecaService.API_GET_getall().subscribe((response: ResponseBiblioteca) => {
      this.archivosGenerales = response.payload;
      this.spinner.hide();
    },
    (err) => {
      console.log(err);
      this.spinner.hide();
    });
  }

  verDocumento(archivo:BibliotecaModel){
    this.url = this.apiEndpoint + "biblioteca/obtenerArchivo/"+archivo.id;
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInforme, { size: 'xl' });
  }

  verDocumentoJardin(documento:string){
    let urlDoc = "";
    console.log(documento);
    switch(documento){
      case 'pei':{
        urlDoc = this.apiEndpoint + "jardin/imprimirProyectoEducativo/" + this.dataJardin.idJardinPeriodo;
        break;
      }
      case 'plan-mejora':{
        urlDoc = this.apiEndpoint + "jardin/imprimirInformePME/" + this.dataJardin.idJardinPeriodo;
        break;
      }
      case 'plan-convivencia':{
        urlDoc = this.apiEndpoint + "planGestionConvivencia/imprimir/"+this.dataJardin.idJardinPeriodo;
        break;
      }
      case 'reglamento':{
        urlDoc = this.apiEndpoint + "reglamentoInterno/imprimir/"+this.dataJardin.idJardinPeriodo;
        break;
      }
    }
    console.log(urlDoc);
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(urlDoc);
    this.modal.open(this.modalInforme, { size: 'xl' });
  }

  getSelectCuentas(){
    this.api.API_POST_getSelectCuentas().subscribe((response: ResponseCuentasModel) => {
          this.infoSelectJardin = response.payload
          this.regiones = this.infoSelectJardin.regiones;
          this.programas = this.infoSelectJardin.programas;
          if(this.region != null){
            this.idRegion = this.region.idRegion;
            this.seleccionarRegion(this.region.idRegion);
          }
          this.getServerData(); 
          this.spinner.hide();
        },
        (err) => {
          console.log(err)
        })
  }

  public getServerData(event?:PageEvent){
    this.callData(event != null ? event : null );
  }

  public callData(event?:PageEvent){
    this.spinner.show();
    let pageNum = event != null ? (event.pageIndex + 1) : 1;
    let pageSize = event != null ? event.pageSize : 10;
    this.api.API_POST_getPlanGestionConvivenciaDetalle(pageNum,pageSize,this.palabraClave,this.idRegion,this.idComuna,this.idPrograma).subscribe((response: any) => {
      this.displayedColumns = this.columnNames.map(x => x.id);
      this.dataSource = new MatTableDataSource<CuentasJardinModel>(response.payload.list);
      this.pageIndex = (response.payload.pageNum - 1);
      this.length = response.payload.total;

      setTimeout(() => {

        this.dataSource.paginator = this.paginator;
        this.spinner.hide();
      }, 1000);

    },
    (err) => {
      console.log("error"+err);
    });
  }

  close(){
    this.modal.dismissAll();
  }

  buscar(palabraClave){
    this.palabraClave = palabraClave;
    this.callData(null);
  }

  seleccionarRegion(value){
    this.idRegion = value;
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(value);
    this.arrayComunas = this.infoSelectJardin.regiones[indexRegion].comunas;
    this.callData(null);
  }

  seleccionarComuna(value){
    this.idComuna = value;
    this.callData(null);
  }

  seleccionarPrograma(value){
    this.idPrograma = value;
    this.callData(null);
  }

  nombreRegion(id){
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(id);
    return this.infoSelectJardin.regiones[indexRegion].nombre;
  }

  nombreComuna(idRegion,IdComuna){
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(idRegion);
    const indexComuna = this.infoSelectJardin.regiones[indexRegion].comunas.map(element => element.idComuna).indexOf(IdComuna);
    return this.infoSelectJardin.regiones[indexRegion].comunas[indexComuna].nombre;
  }

  cargarArchivo(){
    this.modal.open(this.modalCargarArchivo, { size: 'lg' });
  }

  cambioArchivo(event){
    this.dataArchivo = new FormData();
    const extension = event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf(".") + 1, event.target.files[0].name.length)
    const extensionesValidas = ["pdf"];
    const existeExtension = extensionesValidas.map(x=> x).indexOf(extension.toLowerCase());

    if(existeExtension == -1){
      Swal.fire({
        title: 'Error!',
        text: 'Ingrese un archivo valido',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }else{
      this.dataArchivo.append('file', event.target.files[0]);
      this.archivoCargado = false;
    }
  }

  subirArchivo(event){

    this.spinner.show();
    this.dataArchivo.append('nombre', this.nombreArchivo);
    this.api.API_POST_guardarArchivoBiblioteca(this.dataArchivo).subscribe((response) => {
      this.spinner.hide();
      this.close();
      this.getDocuments();
    },
    (err) => {
      Swal.fire({
        title: 'UPS!',
        text: 'El archivo supera el peso máximo (3 mb)',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      console.log(err);
    });

  }

  cancelarArchivo(){
    this.inputArchivo.nativeElement.value = null;
  }

  eliminarArchivo(id){
    Swal.fire({
      title: '¿Está seguro de eliminar este archivo?',
      text: "Esta acción no se puede deshacer",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.api.API_POST_eliminarArchivoBiblioteca(id).subscribe((response) => {
          this.getDocuments();
          this.spinner.hide();
        },
        (err) => {
            Swal.fire({
              title: 'Error',
              text: 'Error al eliminar archivo',
              icon: 'error',
              confirmButtonText: 'OK'
            });
            console.log(err);
          });
      }
    });
  }
}
